import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  align: {
    type: 'string',
    default: 'full',
  },
  title: {
    type: 'string',
    default: 'Mais de 1,5 milhão de brasileiros escolheram crescer com a gente',
  },
  description: {
    type: 'string',
    default:
      'E você ainda na dúvida se deve assinar uma internet que realmente funciona? É só lembrar que com a gente você também vai economizar o seu dinheiro.',
  },
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  subDescription: {
    type: 'string',
    default:
      'Estamos há 17 anos no mercado de Telecomunicações, e já chegamos em mais de 70 cidades pelo Sudeste e Distrito Federal. Tudo isso só foi possível porque entregamos internet de verdade aos nossos clientes.',
  },
  button: {
    type: 'string',
    default: '',
  },
  hrefLink: {
    type: 'string',
  },
  icon: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  ...Common,
};
